"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = exports.checkStatus = void 0;
const utils_1 = require("./../utils");
class ResponseError extends Error {
    constructor(message, response) {
        super(message);
        Object.setPrototypeOf(this, ResponseError.prototype);
        this.response = response;
    }
}
/**
 * @param {HttpResponse<T>} response response from fetch
 * @returns {HttpResponse<T>} response
 */
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new ResponseError(response.statusText, response);
    throw error;
}
exports.checkStatus = checkStatus;
/**
 * Note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
 * which is necessary for analytics and such
 * @param {string} url url to fetch
 * @param {unknown[]} data data to send
 * @param {HttpDataFetcher<T>} fetcher data fetcher
 * @param {querystring.ParsedUrlQueryInput} params additional params to send
 */
function fetchData(url, data, fetcher, params = {}) {
    return fetcher((0, utils_1.resolveUrl)(url, params), data)
        .then(checkStatus)
        .then((response) => {
        // axios auto-parses JSON responses, don't need to JSON.parse
        return response.data;
    });
}
/**
 * Resolve tracking endpoint url
 * @param {TrackingRequestOptions} options options for the tracking service
 * @returns {string} tracking api url
 */
function resolveTrackingUrl(options) {
    const { host = '', serviceUrl = '/sitecore/api/jss/track', action = 'event' } = options;
    return `${host}${serviceUrl}/${action}`;
}
/**
 * Makes a request to Sitecore Layout Service for the specified route item path.
 * @param {Array<EventInstance | GoalInstance | OutcomeInstance | CampaignInstance | PageViewInstance>} events events to send
 * @param {TrackingRequestOptions} options options for the tracking service
 * @returns {Promise<void>} void
 */
function trackEvent(events, options) {
    const { querystringParams } = options;
    if (!options.test && (0, utils_1.isServer)()) {
        // do nothing for SSR, only track events when a browser requests it
        return Promise.resolve();
    }
    if (!Array.isArray(events)) {
        events = [events];
    }
    const fetchUrl = resolveTrackingUrl(options);
    return fetchData(fetchUrl, events, options.fetcher, querystringParams);
}
exports.trackEvent = trackEvent;
